import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import { generatePricingReport, getPremiumPayout } from "apis";
import { StationContext } from "contexts";
import { Intro } from "components/commons";
import useDataTable from "hooks/useDataTable";
import locale from "localization";

import { premiumPayoutFilterState } from "./premium-payout-filter.state";
import { mapFilterToRequest, mapDataToList } from "./premium-payout.mapper";
import { premiumPayoutColumns } from "./premium-payout-column";
import PremiumPayoutFilter from "./premium-payout-filter";
import PremiumPayoutList from "./premium-payout.list";
import styles from "./premium-payout.module.scss";
import { useExport } from "hooks";

const PremiumPayoutModule = () => {
  const history = useHistory();

  const { station } = useContext(StationContext);
  const { stationId } = station;

  const { filter, search, table } = useDataTable({
    api: { api: getPremiumPayout, params: { stationId } },
    filter: { initialState: premiumPayoutFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "premiumPayouts",
      mapper: (premiumPayouts) =>
        mapDataToList({
          premiumPayouts,
          history,
        }),
      columns: premiumPayoutColumns,
    },
  });

  const exportReport = useExport({
    api: generatePricingReport,
    reportType: "premium-payout",
    mappedFilterState: { ...filter.mappedFilterState, stationId, settlementType: "premium-payout" },
  });

  return (
    <>
      <Intro title={locale.monthlyPremiumPayment} subtitle={locale.viewAndTrackMonthlyPremium} />
      <PremiumPayoutFilter {...filter} {...search} {...exportReport} />
      <div className={styles.table}>
        <PremiumPayoutList table={table} />
      </div>
    </>
  );
};

export default PremiumPayoutModule;
